if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.isDesktopSlider = this.classList.contains('product__slider-slider-grid');
      this.slides = this.querySelectorAll('.product__slide');
      this.isNav = this.dataset.type == 'nav';
      this.cellSelector = this.isNav ? 'js-thumb-slide' : 'js-main-slide';
      this.style.display = 'flex';
    }

    connectedCallback() {
      this.initScrollEffect();
    }

    initScrollEffect() {
      // Check if viewport width is more than 767px and if isDesktopSlider is false
      if (window.innerWidth > 767 && !this.isDesktopSlider) {
        return; // exit the function. This means we are on a large screen and we do not want to render slider mode.
      }

      this.activeSlides = this.querySelectorAll(`.${this.cellSelector}`);
      let _that = this;
      let columnDivider = 2;
      let scrollContainer = window;

      if(this.activeSlides.length <= 0) {
        this.activeSlides = this.querySelectorAll(`.product__slide`);
        this.activeSlides.forEach((image) => image.classList.add('js-main-slide'));
      }

      if(this.closest('quick-add-modal')){
        columnDivider = 1;
        scrollContainer = this.closest('.quick-add-modal__content')
      }

      // add indicators
      const totalIndicators = Math.round(this.activeSlides.length / columnDivider);

      this.querySelector('.indicators')?.remove();
      if(totalIndicators > 1) {
        let indicatorsDiv = document.createElement('ul');
        indicatorsDiv.classList.add('indicators');

        for(var i= 1; i <= totalIndicators; i++) {
          indicatorsDiv.innerHTML += `<li class="${i === 1 ? 'current' : ''}"></li>`;
        }

        this.appendChild(indicatorsDiv);
      }

      if(!this.addedScrollEvent) {
        this.addedScrollEvent = true;
        this.currentPage = 1;
        scrollContainer.addEventListener('scroll', function(){
          let scrollPos = scrollContainer.pageYOffset;
          let found = false;
          _that.activeSlides.forEach((slide) => {
            if(!found && slide.offsetTop >= scrollPos) {
              found = true;
              _that.activeSlides.forEach((__slide, index) => {
                __slide.classList.remove('currentpage');
                if(__slide === slide) {
                  _that.currentPage = Math.round((index + 1) / columnDivider);
                  slide.classList.add('currentpage');
                }
              });

              _that.updateIndicators();
            }
          });
        });
      }
    }

    updateIndicators() {
      let indicatorsLi = this.querySelectorAll('.indicators li');

      // remove current class from previous page
      indicatorsLi?.forEach((li) => li.classList.remove('current'));

      // add current class to current page
      indicatorsLi[this.currentPage - 1]?.classList.add('current');
    }

  }

  customElements.define('product-media', ProductMedia);
}
